// extracted by mini-css-extract-plugin
export default {"container":"ShowErrors_container__h0mSj","error":"ShowErrors_error__GjmM0"};